module.exports = __webpack_public_path__ + "img/5.6.B.564ec23a.png";